/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ACS } from './ACS';
import {
    ACSFromJSON,
    ACSFromJSONTyped,
    ACSToJSON,
} from './ACS';
import type { TransactionIn } from './TransactionIn';
import {
    TransactionInFromJSON,
    TransactionInFromJSONTyped,
    TransactionInToJSON,
} from './TransactionIn';

/**
 * 
 * @export
 * @interface MoneyIn3DInitOutput
 */
export interface MoneyIn3DInitOutput {
    /**
     * 
     * @type {ACS}
     * @memberof MoneyIn3DInitOutput
     */
    acs?: ACS;
    /**
     * 
     * @type {TransactionIn}
     * @memberof MoneyIn3DInitOutput
     */
    transaction?: TransactionIn;
    /**
     * 
     * @type {Error}
     * @memberof MoneyIn3DInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyIn3DInitOutput interface.
 */
export function instanceOfMoneyIn3DInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyIn3DInitOutputFromJSON(json: any): MoneyIn3DInitOutput {
    return MoneyIn3DInitOutputFromJSONTyped(json, false);
}

export function MoneyIn3DInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyIn3DInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acs': !exists(json, 'acs') ? undefined : ACSFromJSON(json['acs']),
        'transaction': !exists(json, 'transaction') ? undefined : TransactionInFromJSON(json['transaction']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyIn3DInitOutputToJSON(value?: MoneyIn3DInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acs': ACSToJSON(value.acs),
        'transaction': TransactionInToJSON(value.transaction),
        'error': value.error,
    };
}

